import { useStaticQuery, graphql } from "gatsby";

export const OtherTranslations = () => {
  return useStaticQuery(graphql`
    query OtherTranslationsQuery {
      mb {
        otherTranslation {
          header_home
          header_go_back_to_fcc
          home_featured_topics
          home_browse_resources
          home_additional_resources
          search_sellbox_title
          search_sellbox_topics_description
          search_sellbox_placeholder
          helpful_article_title
          helpful_article_yes_it_was
          helpful_article_no_it_wasnt
          helpful_article_no_form_title
          helpful_article_thank_you_title
          helpful_article_thank_you_message
          helpful_article_send_feedback
          helpful_article_no_placeholder
          helpful_article_error
          helpful_article_please_click_below
          helpful_article_try_again
          helpful_article_answers_option_1
          helpful_article_answers_option_2
          helpful_article_answers_option_3
          helpful_article_answers_option_4
          footer_features
          footer_solutions
          footer_support
          footer_company
          footer_stay_connected
          footer_privacy_policy
          footer_sitemap
          footer_acceptable_use
          footer_terms_for_us_government
          footer_terms_conditions
          footer_column1_link1_label
          footer_column1_link2_label
          footer_column1_link3_label
          footer_column1_link4_label
          footer_column2_link1_label
          footer_column2_link2_label
          footer_column2_link3_label
          footer_column2_link4_label
          footer_column2_link5_label
          footer_column3_link1_label
          footer_column3_link2_label
          footer_column3_link3_label
          footer_column3_link4_label
          footer_column4_link1_label
          footer_column4_link2_label
          footer_column4_link3_label
          footer_column4_link4_label
          footer_column5_link1_label
          footer_column5_link2_label
          footer_column5_link3_label
          footer_column1_link1
          footer_column1_link2
          footer_column1_link3
          footer_column1_link4
          footer_column2_link1
          footer_column2_link2
          footer_column2_link3
          footer_column2_link4
          footer_column2_link5
          footer_column3_link1
          footer_column3_link2
          footer_column3_link3
          footer_column3_link4
          footer_column4_link1
          footer_column4_link2
          footer_column4_link3
          footer_column4_link4
          footer_column5_link1
          footer_column5_link2
          footer_column5_link3
          not_found_title
          not_found_description
          not_found_return_home
          read_more
          locale
          localizations{
            header_home
            header_go_back_to_fcc
            home_featured_topics
            home_browse_resources
            home_additional_resources
            search_sellbox_title
            search_sellbox_topics_description
            search_sellbox_placeholder
            helpful_article_title
            helpful_article_yes_it_was
            helpful_article_no_it_wasnt
            helpful_article_no_form_title
            helpful_article_thank_you_title
            helpful_article_thank_you_message
            helpful_article_send_feedback
            helpful_article_no_placeholder
            helpful_article_error
            helpful_article_please_click_below
            helpful_article_try_again
            helpful_article_answers_option_1
            helpful_article_answers_option_2
            helpful_article_answers_option_3
            helpful_article_answers_option_4
            footer_features
            footer_solutions
            footer_support
            footer_company
            footer_stay_connected
            footer_privacy_policy
            footer_sitemap
            footer_acceptable_use
            footer_terms_for_us_government
            footer_terms_conditions
            footer_column1_link1_label
            footer_column1_link2_label
            footer_column1_link3_label
            footer_column1_link4_label
            footer_column2_link1_label
            footer_column2_link2_label
            footer_column2_link3_label
            footer_column2_link4_label
            footer_column2_link5_label
            footer_column3_link1_label
            footer_column3_link2_label
            footer_column3_link3_label
            footer_column3_link4_label
            footer_column4_link1_label
            footer_column4_link2_label
            footer_column4_link3_label
            footer_column4_link4_label
            footer_column5_link1_label
            footer_column5_link2_label
            footer_column5_link3_label
            footer_column1_link1
            footer_column1_link2
            footer_column1_link3
            footer_column1_link4
            footer_column2_link1
            footer_column2_link2
            footer_column2_link3
            footer_column2_link4
            footer_column2_link5
            footer_column3_link1
            footer_column3_link2
            footer_column3_link3
            footer_column3_link4
            footer_column4_link1
            footer_column4_link2
            footer_column4_link3
            footer_column4_link4
            footer_column5_link1
            footer_column5_link2
            footer_column5_link3
            not_found_title
            not_found_description
            not_found_return_home
            read_more
            locale
          }
        }
      }
    }
  `);
};
